import { render, staticRenderFns } from "./VoissEditorBrand.vue?vue&type=template&id=2452a138&scoped=true&"
import script from "./VoissEditorBrand.vue?vue&type=script&lang=js&"
export * from "./VoissEditorBrand.vue?vue&type=script&lang=js&"
import style0 from "./VoissEditorBrand.vue?vue&type=style&index=0&id=2452a138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452a138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
